import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { wrapIdForPic } from '@framework/workbench/util/wrap-id-util';
import { TOOLBAR_PICTURE_COLOR_ICON } from '@editor/src/img/pageIndex';


export const config = {
    id: ActionType.PICTURE_COLOR,
    tipMsg: i18n.t('色彩调整'),
    content: i18n.t('色彩调整'),
    icon: TOOLBAR_PICTURE_COLOR_ICON,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForPic(config.id),
        hasArrow: true,
        text: config.content,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
    },
];
